const config = {
  dev: {
    SERVICE_API: 'https://dev-switchpowerapi.hellobike.com/api',
    PLATFORM_API: 'https://newdev-api.hellobike.com/api',
    API_ASYNC: 'https://dev-switchpowerapi.hellobike.com/switchpower/async',
  },
  fat: {
    SERVICE_API: 'https://fat-switchpowerapi.hellobike.com/api',
    PLATFORM_API: 'https://fat-api.hellobike.com/api',
    API_ASYNC: 'https://fat-switchpowerapi.hellobike.com/switchpower/async',
  },
  pt: {
    SERVICE_API: 'https://pt-switchpowerapi.hellobike.com/api',
    PLATFORM_API: 'https://pt-api.hellobike.com/api',
    API_ASYNC: 'https://pt-switchpowerapi.hellobike.com/switchpower/async',
  },
  uat: {
    SERVICE_API: 'https://uat-switchpowerapi.hellobike.com/api',
    PLATFORM_API: 'https://uat-api.hellobike.com/api',
    API_ASYNC: 'https://uat-switchpowerapi.hellobike.com/switchpower/async',
  },
  pre: {
    SERVICE_API: 'https://pre-switchpowerapi.hellobike.com/api',
    PLATFORM_API: 'https://pre-api.hellobike.com/api',
    API_ASYNC: 'https://pre-switchpowerapi.hellobike.com/switchpower/async',
  },
  pro: {
    SERVICE_API: 'https://switchpowerapi.hellobike.com/api',
    PLATFORM_API: 'https://api.hellobike.com/api',
    API_ASYNC: 'https://switchpowerapi.hellobike.com/switchpower/async',
  },
};

export const fullConfig = config;
export default config[process.env.VUE_APP_ENV];
